export const TOOLTIPS = {
  ltp: [
    { id: 1, text: "Last Traded Price" },
    { id: 2, text: "Current market price of the stock" },
    { id: 3, text: "Latest executed trade price" },
  ],

  open: [
    { id: 1, text: "First traded price when market opened today" },
    { id: 2, text: "Used to identify Gap Up or Gap Down openings" },
    { id: 3, text: "Open above previous close = Gap Up" },
    { id: 4, text: "Open below previous close = Gap Down" },
  ],

  high: [
    { id: 1, text: "Highest price traded during today's session" },
    { id: 2, text: "Acts as intraday resistance" },
    { id: 3, text: "Breaking day's high often signals strength" },
  ],

  low: [
    { id: 1, text: "Lowest price traded during today's session" },
    { id: 2, text: "Acts as intraday support" },
    { id: 3, text: "Breaking day's low often signals weakness" },
  ],

  close: [
    { id: 1, text: "Previous trading day's closing price" },
    { id: 2, text: "Reference point for daily performance" },
    { id: 3, text: "Used to calculate percentage change" },
  ],

  percentChange: [
    { id: 1, text: "Percentage move from previous close" },
    { id: 2, text: "Positive value means stock is gaining" },
    { id: 3, text: "Negative value means stock is falling" },
    { id: 4, text: "Calculated using LTP and Close" },
  ],

  forecastPrice: [
    { id: 1, text: "AI projected future price level" },
    { id: 2, text: "Generated using technical and market analysis" },
    { id: 3, text: "Not a guaranteed target" },
    { id: 4, text: "Use along with risk management" },
  ],

  forecastRange: [
    { id: 1, text: "Expected future trading range" },
    { id: 2, text: "Low = Conservative estimate" },
    { id: 3, text: "High = Optimistic estimate" },
    { id: 4, text: "Generated from prediction models" },
  ],

  vwap: [
    { id: 1, text: "Volume Weighted Average Price" },
    { id: 2, text: "Average traded price weighted by volume" },
    { id: 3, text: "Institutional benchmark price" },
    { id: 4, text: "Above VWAP = Bullish" },
    { id: 5, text: "Below VWAP = Bearish" },
  ],

  dayRange: [
    { id: 1, text: "Today's trading range" },
    { id: 2, text: "Difference between today's High and Low" },
    { id: 3, text: "Large range indicates high volatility" },
  ],

  week52Range: [
    { id: 1, text: "Highest and lowest price in last 52 weeks" },
    { id: 2, text: "Shows long-term stock performance" },
    { id: 3, text: "Near 52W High = Strong trend" },
    { id: 4, text: "Near 52W Low = Weak trend" },
  ],

  rsi: [
    { id: 1, text: "Relative Strength Index" },
    { id: 2, text: "Momentum indicator ranging from 0 to 100" },
    { id: 3, text: "Above 70 = Overbought" },
    { id: 4, text: "Below 30 = Oversold" },
    { id: 5, text: "Around 50 = Neutral momentum" },
  ],

  macd: [
    { id: 1, text: "Moving Average Convergence Divergence" },
    { id: 2, text: "Trend and momentum indicator" },
    { id: 3, text: "MACD above Signal = Bullish" },
    { id: 4, text: "MACD below Signal = Bearish" },
    { id: 5, text: "Crossovers generate Buy/Sell signals" },
  ],

  volume: [
    { id: 1, text: "Total quantity traded today" },
    { id: 2, text: "High volume confirms price movement" },
    { id: 3, text: "Low volume may indicate weak conviction" },
  ],

  rsiMacdSignal: [
    { id: 1, text: "Combined RSI and MACD analysis" },
    { id: 2, text: "Bullish = Momentum strengthening" },
    { id: 3, text: "Bearish = Momentum weakening" },
    { id: 4, text: "Higher reliability when both agree" },
  ],

  vwapMomentum: [
    { id: 1, text: "Intraday momentum based on VWAP" },
    { id: 2, text: "Above VWAP = Buyers in control" },
    { id: 3, text: "Below VWAP = Sellers in control" },
    { id: 4, text: "Near VWAP = Neutral zone" },
  ],

  utBot: [
    { id: 1, text: "ATR based trend-following indicator" },
    { id: 2, text: "BUY = Bullish trend detected" },
    { id: 3, text: "SELL = Bearish trend detected" },
    { id: 4, text: "Designed to capture trend reversals" },
  ],

  bbSignal: [
    { id: 1, text: "Bollinger Band based signal" },
    { id: 2, text: "BUY = Potential bullish reversal" },
    { id: 3, text: "SELL = Potential bearish reversal" },
    { id: 4, text: "Measures volatility and trend strength" },
  ],

  movingAverage: [
    { id: 1, text: "Price compared with moving averages" },
    { id: 2, text: "Above MA = Buy signal" },
    { id: 3, text: "Below MA = Sell signal" },
    { id: 4, text: "More Buy signals indicate stronger trend" },
  ],
  returnPerformance: [
    {
      id: 1,
      text: "Shows stock performance over multiple investment periods.",
    },

    {
      id: 2,
      text: "Helps compare short-term and long-term trends.",
    },

    {
      id: 3,
      text: "Positive values indicate gains while negative values indicate losses.",
    },

    {
      id: 4,
      text: "Calculated using historical closing prices.",
    },
  ],

  oneWeekReturn: [
    {
      id: 1,
      text: "Percentage return generated over the last 1 week.",
    },
  ],

  oneMonthReturn: [
    {
      id: 1,
      text: "Percentage return generated over the last 1 month.",
    },
  ],

  ytdReturn: [
    {
      id: 1,
      text: "Year-to-Date return from the beginning of the current year.",
    },
  ],

  oneYearReturn: [
    {
      id: 1,
      text: "Percentage return generated over the last 1 year.",
    },
  ],

  threeYearReturn: [
    {
      id: 1,
      text: "Annualized performance over the last 3 years.",
    },
  ],

  fiveYearReturn: [
    {
      id: 1,
      text: "Annualized performance over the last 5 years.",
    },
  ],
  pivotLevels: [
    { id: 1, text: "Support and resistance levels" },
    { id: 2, text: "R1-R3 = Resistance zones" },
    { id: 3, text: "S1-S3 = Support zones" },
    { id: 4, text: "Pivot is the key decision level" },
  ],

  orderBook: [
    { id: 1, text: "Live buy and sell orders" },
    { id: 2, text: "More buyers = Bullish sentiment" },
    { id: 3, text: "More sellers = Bearish sentiment" },
    { id: 4, text: "Useful for intraday analysis" },
  ],

  peRatio: [
    { id: 1, text: "Price divided by Earnings Per Share" },
    { id: 2, text: "Measures stock valuation" },
    { id: 3, text: "High P/E may indicate growth expectations" },
    { id: 4, text: "Low P/E may indicate undervaluation or slower growth" },
  ],

  upside: [
    { id: 1, text: "Potential gain from current price to forecast price" },
    { id: 2, text: "Higher percentage indicates larger upside potential" },
  ],
  optionChain: [
    { id: 1, text: "Shows Call and Put option data" },
    { id: 2, text: "Useful for support, resistance and market sentiment" },
    { id: 3, text: "High Call OI can act as resistance" },
    { id: 4, text: "High Put OI can act as support" },
  ],

  maxPain: [
    { id: 1, text: "Price where option buyers lose the most money" },
    { id: 2, text: "Often used to estimate expiry pressure zone" },
    { id: 3, text: "Stock may move near Max Pain around expiry" },
    { id: 4, text: "Use only as supporting data, not alone" },
  ],
  macdCrossover: [
    { id: 1, text: "Detects when MACD line crosses the Signal line" },
    {
      id: 2,
      text: "Bullish Crossover = MACD was below Signal, now crossed above",
    },
    {
      id: 3,
      text: "Bearish Crossover = MACD was above Signal, now crossed below",
    },
    {
      id: 4,
      text: "Compares current and previous bar's MACD vs Signal position",
    },
    {
      id: 5,
      text: "Crossover is a timing signal — it tells you a momentum shift just happened",
    },
  ],

  macdSignalLine: [
    { id: 1, text: "Signal Line is the 9-period EMA of the MACD line" },
    { id: 2, text: "Acts as a smoother version of MACD to reduce noise" },
    { id: 3, text: "When MACD crosses above Signal Line = Bullish signal" },
    { id: 4, text: "When MACD crosses below Signal Line = Bearish signal" },
    { id: 5, text: "Used alongside MACD to generate crossover signals" },
  ],

  macdHistogram: [
    { id: 1, text: "Histogram = MACD Line minus Signal Line" },
    {
      id: 2,
      text: "Positive histogram = MACD is above Signal (bullish momentum)",
    },
    {
      id: 3,
      text: "Negative histogram = MACD is below Signal (bearish momentum)",
    },
    { id: 4, text: "Growing bars = Momentum strengthening" },
    {
      id: 5,
      text: "Shrinking bars = Momentum weakening, possible reversal ahead",
    },
    { id: 6, text: "Histogram crossing zero confirms a MACD crossover event" },
  ],

  momentum: [
    { id: 1, text: "Combined momentum verdict using RSI + MACD + Histogram" },
    { id: 2, text: "Bullish = RSI > 55 AND MACD > Signal AND Histogram > 0" },
    { id: 3, text: "Bearish = RSI < 45 AND MACD < Signal AND Histogram < 0" },
    {
      id: 4,
      text: "Neutral = Conditions don't fully align for Bullish or Bearish",
    },
    {
      id: 5,
      text: "Unlike Crossover (timing signal), Momentum shows overall stance right now",
    },
  ],

  momentumResult: [
    { id: 1, text: "Descriptive outcome of the Momentum verdict" },
    {
      id: 2,
      text: "Strong Bullish Momentum = All three indicators confirm uptrend",
    },
    {
      id: 3,
      text: "Strong Bearish Momentum = All three indicators confirm downtrend",
    },
    {
      id: 4,
      text: "Neutral / Sideways Market = Mixed or inconclusive signals",
    },
  ],
  vwapKeyLevels: [
    { id: 1, text: "VWAP based entry, target and stop-loss analysis" },
    { id: 2, text: "Shows whether price is bullish or bearish intraday" },
    { id: 3, text: "Combines VWAP with nearest support and resistance" },
    { id: 4, text: "Useful mainly for intraday trading decisions" },
  ],
  // technicalScore: [
  //   {
  //     id: 1,
  //     text: "Overall technical score derived from RSI, MACD, VWAP, Momentum and Smart Money.",
  //   },
  //   {
  //     id: 2,
  //     text: "Provides a quick view of the stock's overall technical strength.",
  //   },
  //   {
  //     id: 3,
  //     text: "Score Range: 0-29 Strong Bearish | 30-44 Bearish | 45-54 Neutral | 55-69 Moderately Bullish | 70-84 Bullish | 85-100 Strong Bullish.",
  //   },
  // ],

  // rsiMacdScore: [
  //   {
  //     id: 1,
  //     text: "Measures trend strength using RSI, MACD and MACD Histogram.",
  //   },
  //   {
  //     id: 2,
  //     text: "Higher scores indicate stronger momentum confirmation.",
  //   },
  //   {
  //     id: 3,
  //     text: "Score Range: 0-29 Strong Bearish | 30-44 Bearish | 45-54 Neutral | 55-69 Moderately Bullish | 70-84 Bullish | 85-100 Strong Bullish.",
  //   },
  // ],

  // vwapScore: [
  //   {
  //     id: 1,
  //     text: "Measures price position relative to VWAP.",
  //   },
  //   {
  //     id: 2,
  //     text: "Higher values indicate stronger intraday buying pressure.",
  //   },
  //   {
  //     id: 3,
  //     text: "Score Range: 0-29 Strong Bearish | 30-44 Bearish | 45-54 Neutral | 55-69 Moderately Bullish | 70-84 Bullish | 85-100 Strong Bullish.",
  //   },
  // ],

  // momentumScore: [
  //   {
  //     id: 1,
  //     text: "Combines RSI MACD prediction, UT Bot and Bollinger Band signals.",
  //   },
  //   {
  //     id: 2,
  //     text: "Multiple bullish confirmations increase the score.",
  //   },
  //   {
  //     id: 3,
  //     text: "Score Range: 0-29 Strong Bearish | 30-44 Bearish | 45-54 Neutral | 55-69 Moderately Bullish | 70-84 Bullish | 85-100 Strong Bullish.",
  //   },
  // ],

  // smartMoneyScore: [
  //   {
  //     id: 1,
  //     text: "Tracks institutional style money flow using CMF, RVOL and accumulation/distribution.",
  //   },
  //   {
  //     id: 2,
  //     text: "Higher values indicate stronger participation from smart money.",
  //   },
  //   {
  //     id: 3,
  //     text: "Score Range: 0-19 Heavy Distribution | 20-39 Distribution | 40-59 Neutral | 60-79 Accumulation | 80-100 Strong Accumulation.",
  //   },
  // ],

  technicalScore: [
    {
      id: 1,
      text: "Overall = RSI MACD 30% + VWAP 25% + Smart Money 25% + Momentum 20%.",
    },
    {
      id: 2,
      text: "Calculated dynamically in frontend using live snapshot data.",
    },
    {
      id: 3,
      text: "0-29 Strong Bearish | 30-44 Bearish | 45-54 Neutral | 55-69 Moderately Bullish | 70-84 Bullish | 85-100 Strong Bullish.",
    },
  ],

  rsiMacdScore: [
    {
      id: 1,
      text: "Starts from base score 50.",
    },
    {
      id: 2,
      text: "RSI: ≥70 +20 | ≥60 +15 | ≥50 +10 | ≥45 +5 | ≤40 -15 | ≤30 -20.",
    },
    {
      id: 3,
      text: "MACD: Above Signal +15 | Below Signal -15.",
    },
    {
      id: 4,
      text: "Histogram: Positive +10 | Negative -10.",
    },
    {
      id: 5,
      text: "Range: 0-29 Strong Bearish | 30-44 Bearish | 45-54 Neutral | 55-69 Moderately Bullish | 70-84 Bullish | 85-100 Strong Bullish.",
    },
  ],

  vwapScore: [
    {
      id: 1,
      text: "Calculated from LTP distance relative to VWAP.",
    },
    {
      id: 2,
      text: "≥2% = 90 | ≥1% = 80 | ≥0.5% = 70 | ≥0% = 60.",
    },
    {
      id: 3,
      text: "<0% = 40 | ≤-1% = 25 | ≤-2% = 10.",
    },
    {
      id: 4,
      text: "Range: Higher score = stronger intraday buying pressure.",
    },
  ],

  momentumScore: [
    {
      id: 1,
      text: "Starts from base score 50.",
    },
    {
      id: 2,
      text: "RSI MACD Prediction: Bullish +20 | Bearish -20.",
    },
    {
      id: 3,
      text: "UT Bot: Bullish +15 | Bearish -15.",
    },
    {
      id: 4,
      text: "Bollinger/BBAWE: Bullish +15 | Bearish -15.",
    },
    {
      id: 5,
      text: "Range: 0-29 Strong Bearish | 30-44 Bearish | 45-54 Neutral | 55-69 Moderately Bullish | 70-84 Bullish | 85-100 Strong Bullish.",
    },
  ],

  smartMoneyScore: [
    {
      id: 1,
      text: "Generated from Smart Money engine.",
    },
    {
      id: 2,
      text: "Uses CMF, RVOL, OBV trend and accumulation/distribution analysis.",
    },
    {
      id: 3,
      text: "0-19 Heavy Distribution | 20-39 Distribution | 40-59 Neutral | 60-79 Accumulation | 80-100 Strong Accumulation.",
    },
  ],
  trendVolatilityExecution: [
    {
      id: 1,
      text: "This section checks trend execution using UT Bot and volatility breakout confirmation using Bollinger Band/BBAWE.",
    },
    {
      id: 2,
      text: "UT Bot Score shows whether price trend is currently Bullish, Bearish or Neutral.",
    },
    {
      id: 3,
      text: "Bollinger Band Score shows whether volatility and band breakout are supporting the move.",
    },
    {
      id: 4,
      text: "If both UT Bot and Bollinger are Bullish, trend continuation is stronger. If both are Bearish, downside pressure is stronger.",
    },
    {
      id: 5,
      text: "If one is Bullish and one is Bearish/Neutral, the setup is mixed and needs confirmation.",
    },
  ],

  utBotScore: [
    {
      id: 1,
      text: "UT Bot Score is based on the latest UT Bot signal.",
    },
    {
      id: 2,
      text: "Bullish signal gives higher score, Bearish signal gives lower score, Neutral means no clear trend.",
    },
    {
      id: 3,
      text: "Score Range: Bullish = 80, Neutral = 50, Bearish = 20.",
    },
  ],

  bbSignalScore: [
    {
      id: 1,
      text: "Bollinger Band/BBAWE Score is based on the latest Bollinger/BBAWE signal.",
    },
    {
      id: 2,
      text: "BUY/Bullish means volatility supports upside. SELL/Bearish means weakness or breakdown risk.",
    },
    {
      id: 3,
      text: "Score Range: Bullish/BUY = 80, Neutral = 50, Bearish/SELL = 20.",
    },
  ],
  vwapReadout: [
    { id: 1, text: "Shows current price position against VWAP" },
    { id: 2, text: "Above VWAP = Bullish bias" },
    { id: 3, text: "Below VWAP = Bearish bias" },
    { id: 4, text: "Near VWAP = Wait zone" },
  ],

  keyLevels: [
    { id: 1, text: "Nearest support and resistance levels" },
    { id: 2, text: "Resistance can act as target or rejection zone" },
    { id: 3, text: "Support can act as bounce or stop-loss zone" },
  ],

  stopLoss: [
    { id: 1, text: "Risk protection level" },
    { id: 2, text: "Exit if price breaks this level" },
    { id: 3, text: "Helps limit loss in wrong trades" },
  ],

  summarySignal: [
    { id: 1, text: "Final trading summary" },
    { id: 2, text: "Combines VWAP, trend and key levels" },
    { id: 3, text: "Use with confirmation and risk management" },
  ],

  technicalFactors: [
    { id: 1, text: "Indicators used to study price momentum and trend" },
    { id: 2, text: "Includes RSI, MACD and Volume" },
    { id: 3, text: "Useful for short-term trading analysis" },
  ],

  fundamentalFactors: [
    { id: 1, text: "Company valuation and future price potential" },
    { id: 2, text: "Includes upside, forecast price and P/E ratio" },
    { id: 3, text: "Useful for investment-style decisions" },
  ],

  valuationMeasures: [
    { id: 1, text: "Shows how expensive or cheap the company is" },
    { id: 2, text: "Includes Enterprise Value, P/E and Price to Book" },
    { id: 3, text: "Compare with sector peers for better judgment" },
  ],

  enterpriseValue: [
    { id: 1, text: "Total value of the company" },
    { id: 2, text: "Includes market cap, debt and cash adjustment" },
  ],

  forwardPE: [
    { id: 1, text: "Price compared with expected future earnings" },
    { id: 2, text: "Used to judge future valuation" },
  ],

  priceToBook: [
    { id: 1, text: "Stock price compared with book value" },
    { id: 2, text: "Commonly used for banks and asset-heavy companies" },
  ],

  enterpriseToRevenue: [
    { id: 1, text: "Enterprise Value divided by revenue" },
    { id: 2, text: "Shows valuation compared with sales" },
  ],

  profitability: [
    {
      id: 1,
      text: "Shows how efficiently company converts revenue into profit",
    },
    { id: 2, text: "Includes margin, EPS and earnings growth" },
  ],

  profitMargin: [
    { id: 1, text: "Percentage of revenue converted into profit" },
    { id: 2, text: "Higher margin means better profitability" },
  ],

  earningsGrowth: [
    { id: 1, text: "Growth in company earnings compared with previous period" },
    { id: 2, text: "Positive growth indicates improving business performance" },
  ],

  trailingEps: [
    { id: 1, text: "Earnings per share from past reported results" },
    { id: 2, text: "Used to calculate trailing valuation" },
  ],

  forwardEps: [
    { id: 1, text: "Expected future earnings per share" },
    { id: 2, text: "Used for forward-looking valuation" },
  ],

  ownershipRisk: [
    { id: 1, text: "Shows ownership structure and floating shares" },
    { id: 2, text: "Higher institutional holding can indicate confidence" },
    { id: 3, text: "Low float can increase volatility" },
  ],

  insiderHolding: [
    { id: 1, text: "Shares held by promoters, insiders or management" },
    { id: 2, text: "Higher insider holding may show confidence" },
  ],

  institutionalHolding: [
    { id: 1, text: "Shares held by institutions like funds and FIIs" },
    { id: 2, text: "Higher holding may indicate institutional interest" },
  ],

  floatShares: [
    { id: 1, text: "Shares available for public trading" },
    { id: 2, text: "Low float stocks can move sharply" },
  ],

  sharesOutstanding: [
    { id: 1, text: "Total shares issued by the company" },
    { id: 2, text: "Used to calculate market capitalization" },
  ],
  priceChart: [
    { id: 1, text: "Shows historical price movement of the stock" },
    { id: 2, text: "Helps identify trend direction" },
    { id: 3, text: "Higher highs and higher lows indicate an uptrend" },
    { id: 4, text: "Lower highs and lower lows indicate a downtrend" },
    { id: 5, text: "Used together with indicators for better decisions" },
  ],

  candlestickChart: [
    { id: 1, text: "Each candle represents price action during a time period" },
    { id: 2, text: "Body shows Open and Close prices" },
    { id: 3, text: "Wicks show High and Low prices" },
    { id: 4, text: "Green candle = Buyers dominated" },
    { id: 5, text: "Red candle = Sellers dominated" },
    { id: 6, text: "Useful for spotting reversals and breakouts" },
  ],

  macdChart: [
    { id: 1, text: "MACD measures trend strength and momentum" },
    { id: 2, text: "MACD Line crossing above Signal Line = Bullish" },
    { id: 3, text: "MACD Line crossing below Signal Line = Bearish" },
    { id: 4, text: "Histogram shows momentum strength" },
    { id: 5, text: "Best used with price trend confirmation" },
  ],

  macdLine: [
    { id: 1, text: "Difference between fast and slow moving averages" },
    { id: 2, text: "Shows momentum direction" },
    { id: 3, text: "Above zero = Bullish trend" },
    { id: 4, text: "Below zero = Bearish trend" },
  ],

  signalLine: [
    { id: 1, text: "Smoothed average of MACD Line" },
    { id: 2, text: "Used to generate buy and sell signals" },
    { id: 3, text: "MACD crossing above Signal = Buy indication" },
    { id: 4, text: "MACD crossing below Signal = Sell indication" },
  ],

  histogram: [
    { id: 1, text: "Difference between MACD and Signal Line" },
    { id: 2, text: "Growing bars indicate strengthening momentum" },
    { id: 3, text: "Shrinking bars indicate weakening momentum" },
    { id: 4, text: "Crossing zero often signals trend change" },
  ],

  macdCrossover: [
    { id: 1, text: "Occurs when MACD and Signal lines intersect" },
    { id: 2, text: "Bullish crossover may indicate upward momentum" },
    { id: 3, text: "Bearish crossover may indicate downward momentum" },
    { id: 4, text: "Most effective when confirmed by price action" },
  ],

  chartTimeframe: [
    { id: 1, text: "Changes chart analysis period" },
    { id: 2, text: "Minute charts are useful for intraday trading" },
    { id: 3, text: "Daily charts are useful for swing and positional trades" },
    { id: 4, text: "Higher timeframes provide stronger signals" },
  ],

  supportResistanceChart: [
    { id: 1, text: "Support is a zone where buyers may enter" },
    { id: 2, text: "Resistance is a zone where sellers may enter" },
    { id: 3, text: "Breakout above resistance may indicate strength" },
    { id: 4, text: "Breakdown below support may indicate weakness" },
  ],

  volumeChart: [
    { id: 1, text: "Shows trading activity during each period" },
    { id: 2, text: "Higher volume confirms market participation" },
    { id: 3, text: "Price move with high volume is more reliable" },
    { id: 4, text: "Low volume moves may be weak or temporary" },
  ],

  buySellSignalChart: [
    { id: 1, text: "Generated using indicator crossover logic" },
    { id: 2, text: "BUY indicates bullish confirmation" },
    { id: 3, text: "SELL indicates bearish confirmation" },
    { id: 4, text: "Should be combined with support and resistance levels" },
  ],
  vwapReadout: [
    {
      id: 1,
      text: "Shows whether price is near VWAP, above VWAP, or below VWAP.",
    },
    {
      id: 2,
      text: "Basis: LTP is compared with VWAP using a 0.2% entry zone.",
    },
    {
      id: 3,
      text: "If price reclaims VWAP from below, it becomes VWAP Reclaim Buy.",
    },
    {
      id: 4,
      text: "If price is slightly above VWAP, it becomes Pullback Buy.",
    },
  ],
  quantTechnicalScore: [
    {
      id: 1,
      text: "Quant Technical Score is the overall strength score of the stock based on multiple technical signals.",
    },
    {
      id: 2,
      text: "It combines RSI MACD, VWAP, UT Bot, Bollinger Band and Smart Money score.",
    },
    {
      id: 3,
      text: "80-100 means Strong Bullish, 60-79 Bullish, 40-59 Neutral, 20-39 Bearish, 0-19 Strong Bearish.",
    },
    {
      id: 4,
      text: "Use it as a quick summary, not as a standalone buy or sell decision.",
    },
  ],

  keyLevels: [
    {
      id: 1,
      text: "Shows nearest Resistance and Support based on pivot levels.",
    },
    {
      id: 2,
      text: "Resistance is selected from R1, R2, R3 above current LTP.",
    },
    {
      id: 3,
      text: "Support is selected from S1, S2, S3 below current LTP.",
    },
    {
      id: 4,
      text: "Used for possible target and downside reference.",
    },
  ],

  stopLoss: [
    {
      id: 1,
      text: "Stop loss is calculated from VWAP with a small buffer.",
    },
    {
      id: 2,
      text: "If price is above VWAP, SL is placed below VWAP.",
    },
    {
      id: 3,
      text: "If price is below VWAP, SL is placed above VWAP.",
    },
    {
      id: 4,
      text: "Basis used in code: VWAP ± 0.1% buffer.",
    },
  ],

  summary: [
    {
      id: 1,
      text: "Combines VWAP position, entry condition, exit condition, and trader note.",
    },
    {
      id: 2,
      text: "Shows BUY, HOLD, SELL, or WAIT based on current VWAP setup.",
    },
    {
      id: 3,
      text: "Target logic uses around 0.5% to 1% movement from entry.",
    },
  ],
  smartMoney: [
    {
      id: 1,
      text: "Smart Money estimates buying and selling pressure using price, volume, CMF, OBV, RVOL and VWAP analysis.",
    },
    {
      id: 2,
      text: "Intraday mode uses live market data while EOD mode uses daily historical candles.",
    },
    {
      id: 3,
      text: "Used as a confirmation tool alongside RSI, MACD, VWAP and other technical indicators.",
    },
  ],

  smartMoneyStatus: [
    {
      id: 1,
      text: "Overall Smart Money classification based on calculated score.",
    },
    {
      id: 2,
      text: "Strong Accumulation = Strong buying pressure.",
    },
    {
      id: 3,
      text: "Accumulation = Moderate buying pressure.",
    },
    {
      id: 4,
      text: "Neutral = No clear money flow direction.",
    },
    {
      id: 5,
      text: "Distribution = Moderate selling pressure.",
    },
    {
      id: 6,
      text: "Heavy Distribution = Strong selling pressure.",
    },
  ],

  smartMoneyScore: [
    {
      id: 1,
      text: "Combined score generated from CMF, OBV Trend, Relative Volume and VWAP position.",
    },
    {
      id: 2,
      text: "80-100 = Strong Accumulation.",
    },
    {
      id: 3,
      text: "60-80 = Accumulation.",
    },
    {
      id: 4,
      text: "40-60 = Neutral.",
    },
    {
      id: 5,
      text: "20-40 = Distribution.",
    },
    {
      id: 6,
      text: "0-20 = Heavy Distribution.",
    },
  ],

  cmf: [
    {
      id: 1,
      text: "Chaikin Money Flow (CMF) combines price action and volume.",
    },
    {
      id: 2,
      text: "Measures whether money is flowing into or out of a stock.",
    },
    {
      id: 3,
      text: "CMF > 0 indicates buying pressure.",
    },
    {
      id: 4,
      text: "CMF < 0 indicates selling pressure.",
    },
    {
      id: 5,
      text: "CMF > 0.20 suggests strong accumulation.",
    },
    {
      id: 6,
      text: "CMF < -0.20 suggests strong distribution.",
    },
  ],

  obv: [
    {
      id: 1,
      text: "On Balance Volume (OBV) tracks whether volume supports price movement.",
    },
    {
      id: 2,
      text: "Rising OBV indicates accumulation and buying interest.",
    },
    {
      id: 3,
      text: "Falling OBV indicates distribution and selling pressure.",
    },
    {
      id: 4,
      text: "Price rising with rising OBV is generally considered healthy.",
    },
  ],

  rvol: [
    {
      id: 1,
      text: "Relative Volume (RVOL) compares current volume with average volume.",
    },
    {
      id: 2,
      text: "RVOL above 1 means volume is above normal.",
    },
    {
      id: 3,
      text: "RVOL above 1.5 indicates strong participation.",
    },
    {
      id: 4,
      text: "RVOL above 2 indicates unusually high activity.",
    },
  ],

  mfi: [
    {
      id: 1,
      text: "Money Flow Index (MFI) measures money entering or leaving a stock using price and volume.",
    },
    {
      id: 2,
      text: "Often called Volume Weighted RSI.",
    },
    {
      id: 3,
      text: "MFI above 60 indicates positive money flow.",
    },
    {
      id: 4,
      text: "MFI below 40 indicates weak money flow.",
    },
    {
      id: 5,
      text: "Used primarily in EOD Smart Money calculations.",
    },
  ],
  tf: [
    { id: 1, text: "TF — Timeframe" },
    { id: 2, text: "D — Daily" },
    { id: 3, text: "W — Weekly" },
    { id: 4, text: "M — Monthly" },
  ],
  vwapPosition: [
    {
      id: 1,
      text: "VWAP Position compares current price with Volume Weighted Average Price.",
    },
    {
      id: 2,
      text: "Above VWAP indicates buyers are in control.",
    },
    {
      id: 3,
      text: "Below VWAP indicates sellers are in control.",
    },
    {
      id: 4,
      text: "Used in Intraday Smart Money calculations.",
    },
  ],

  breakoutEntry: [
    {
      id: 1,
      text: "Entry price is the high of the bullish MACD crossover candle.",
    },
    {
      id: 2,
      text: "The breakout becomes active when LTP moves above this price.",
    },
    {
      id: 3,
      text: "Entry Price = Crossover High.",
    },
  ],

  crossoverHigh: [
    {
      id: 1,
      text: "Highest price of the candle where the bullish MACD crossover occurred.",
    },
    {
      id: 2,
      text: "Used as the breakout entry or trigger price.",
    },
    {
      id: 3,
      text: "The stock appears in the tracker only when LTP is above this level.",
    },
  ],

  crossoverLow: [
    {
      id: 1,
      text: "Lowest price of the candle where the bullish MACD crossover occurred.",
    },
    {
      id: 2,
      text: "Used for calculating the initial stop-loss.",
    },
    {
      id: 3,
      text: "The stop-loss is limited to a maximum distance of 3% from entry.",
    },
  ],

  breakoutStopLoss: [
    {
      id: 1,
      text: "Price level where the breakout trade should be exited if it fails.",
    },
    {
      id: 2,
      text: "SL = Higher of Crossover Low or 3% below Entry.",
    },
    {
      id: 3,
      text: "Formula: Math.max(Crossover Low, Entry × 0.97).",
    },
    {
      id: 4,
      text: "Using the higher value prevents the initial risk from exceeding 3%.",
    },
  ],

  oneR: [
    {
      id: 1,
      text: "1R represents the initial risk per share.",
    },
    {
      id: 2,
      text: "Formula: 1R = Entry Price − Stop-Loss.",
    },
    {
      id: 3,
      text: "Example: Entry ₹100 and SL ₹97 means 1R = ₹3 per share.",
    },
    {
      id: 4,
      text: "Total risk amount = 1R × Quantity.",
    },
  ],

  riskPercent: [
    {
      id: 1,
      text: "Initial risk per share expressed as a percentage of the entry price.",
    },
    {
      id: 2,
      text: "Formula: Risk % = (1R ÷ Entry Price) × 100.",
    },
    {
      id: 3,
      text: "Example: Entry ₹100 and 1R ₹3 means Risk = 3%.",
    },
  ],

  rMultiple: [
    {
      id: 1,
      text: "Shows the current profit or loss relative to the initial risk.",
    },
    {
      id: 2,
      text: "Formula: R Multiple = (LTP − Entry Price) ÷ 1R.",
    },
    {
      id: 3,
      text: "1R means profit equals the initial risk taken.",
    },
    {
      id: 4,
      text: "2R means profit is twice the initial risk; -1R means the stop-loss is reached.",
    },
    {
      id: 5,
      text: "Example: Entry ₹100, SL ₹97 and LTP ₹106 gives 2R.",
    },
  ],

  breakoutTarget1: [
    {
      id: 1,
      text: "First profit target based on a 1:2 risk-reward ratio.",
    },
    {
      id: 2,
      text: "Formula: T1 = Entry Price + (2 × 1R).",
    },
    {
      id: 3,
      text: "Example: Entry ₹100 and 1R ₹3 gives T1 = ₹106.",
    },
  ],

  breakoutTarget2: [
    {
      id: 1,
      text: "Second profit target based on a 1:3 risk-reward ratio.",
    },
    {
      id: 2,
      text: "Formula: T2 = Entry Price + (3 × 1R).",
    },
    {
      id: 3,
      text: "Example: Entry ₹100 and 1R ₹3 gives T2 = ₹109.",
    },
  ],

  breakoutPnlPoints: [
    {
      id: 1,
      text: "Current price gain or loss per share from the breakout entry.",
    },
    {
      id: 2,
      text: "Formula: P&L per Share = LTP − Entry Price.",
    },
    {
      id: 3,
      text: "This value is not the total trade profit because quantity is not included.",
    },
    {
      id: 4,
      text: "Total P&L = P&L per Share × Quantity.",
    },
  ],

  breakoutPnlPercent: [
    {
      id: 1,
      text: "Percentage gain or loss from the breakout entry price.",
    },
    {
      id: 2,
      text: "Formula: P&L % = ((LTP − Entry) ÷ Entry) × 100.",
    },
    {
      id: 3,
      text: "Positive means price is above entry; negative means price is below entry.",
    },
  ],

  breakoutStatus: [
    {
      id: 1,
      text: "Running means the price is above entry but has not reached T1.",
    },
    {
      id: 2,
      text: "T1 Hit means the price has reached the 2R target.",
    },
    {
      id: 3,
      text: "T2 Hit means the price has reached the 3R target.",
    },
    {
      id: 4,
      text: "Status is calculated using the current LTP.",
    },
  ],
};

export const DASHTOOL = {
  topGainers: [
    {
      id: 1,
      text: "Stocks with the highest percentage gains during the trading session.",
    },
  ],

  topLosers: [
    {
      id: 1,
      text: "Stocks with the largest percentage declines during the trading session.",
    },
  ],

  mostActive: [
    {
      id: 1,
      text: "Stocks with the highest trading volume and market participation.",
    },
  ],

  advances: [
    {
      id: 1,
      text: "Number of stocks trading above their previous closing price.",
    },
  ],

  declines: [
    {
      id: 1,
      text: "Number of stocks trading below their previous closing price.",
    },
  ],

  unchanged: [
    {
      id: 1,
      text: "Number of stocks trading with little or no change from the previous close.",
    },
  ],

  marketBreadth: [
    {
      id: 1,
      text: "Measures overall market strength using advances, declines and unchanged stocks.",
    },
  ],

  indexSelector: [
    {
      id: 1,
      text: "Select an index to view its market movers and performance statistics.",
    },
  ],

  marketMovers: [
    {
      id: 1,
      text: "Highlights the strongest gainers, biggest losers and most active stocks in the selected index.",
    },
  ],
  advances: [
    {
      id: 1,
      text: "Number of stocks trading higher than their previous closing price. Higher advances indicate broad market participation and bullish sentiment.",
    },
  ],

  declines: [
    {
      id: 1,
      text: "Number of stocks trading lower than their previous closing price. Higher declines indicate widespread selling pressure and bearish sentiment.",
    },
  ],

  unchanged: [
    {
      id: 1,
      text: "Number of stocks trading near their previous closing price with little or no movement. High unchanged stocks may indicate a neutral or indecisive market.",
    },
  ],
};
